// extracted by mini-css-extract-plugin
export default {"formFields":"InvitationSettings-module__formFields--YZhfA","formFooter":"InvitationSettings-module__formFooter--Y3Go8"};